import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import { IRealEstateEvent } from '../interfaces';
import { deleteRealEstateEvent, restoreRealEstateEvent } from '../api';

function useDeleteOrRestoreRealEstateEvent(realEstateEvent: IRealEstateEvent, onDeleteOrRestore?: () => void) {
  const { enqueueSnackbar } = useSnackbar();

  const [state, setState] = useState<{ loading: boolean; error: string | null }>({ loading: false, error: null });

  async function handleDeleteOrRestoreEvent() {
    if (!realEstateEvent.realEstateEventId) return;

    try {
      setState({ loading: true, error: null });

      await (realEstateEvent.isDeleted ? restoreRealEstateEvent : deleteRealEstateEvent)(
        realEstateEvent.realEstateEventId,
      );

      if (onDeleteOrRestore) onDeleteOrRestore();
    } catch (error) {
      const message = (error as AxiosError).response?.data.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { handleDeleteOrRestoreEvent, deleteOrRestoreEventState: state };
}

export default useDeleteOrRestoreRealEstateEvent;
